<div class="UNFAPP-asmnt-full-area">
  <div class="container-fluid">
      <div class="row">
          <div class="col-xl-2 col-md-3">
            <app-sidebar></app-sidebar>
            <!-- <app-peakmind-card class="m-hide"></app-peakmind-card> -->
          </div><!-- left menu area closed -->
          <div class="col-xl-10 col-md-9">
              <div class="UNFAPP-asmnt-rgt-area">


                  <div class="UNFAPP-asmnt-hdng-area UNFAPP-maintitle-asmnt-hdng">
                      <h3 class="UNFAPP-hdng">Hello {{userData?.firstName + ' ' + userData?.lastName}}</h3>
                      <button class="UNFAPP-tpblu-subjctlink UNFAPP-m-hide" (click)="openFocusExamDialog()" *ngIf="userData?.exams.length > 1">{{displayExamName}} - Grade {{userData?.grade?.name.replace('th', '')}}<i class="fa fa-caret-down" aria-hidden="true"></i></button>
                  </div>

                  <ng-container *ngIf="showDefault == true">
                    <!-- <div class="UNFAPP-asmnt-bnr-area">
                        <img src="assets/img/assessment/asmnt-winner-batch.png" class="UNFAPP-asmnt-wnrbch-img" alt="" />
                        <div><img src="assets/img/assessment/asmnt-bnnr-student.png" alt="" class="bnner-studnt" /></div>
                        <div class="UNFAPP-asmnt-bnr-info">
                            <h2 class="h2-bnnr-hdng">India’s no. 1 Scholarship Test</h2>
                            <h4 class="h4-bnnr-hdng">Limited Seats available</h4>
                            <h3 class="h3-bnnr-hdng">Book for <span class="line-through">Rs 249</span> <span class="big-price">Rs 99</span></h3>
                        </div>
                        <button class="UNFAPP-asmnt-bnr-btn">Register NOW</button>
                    </div> -->
                    <div class="UNFAPP-hero-bnnr" (click)="fireBaseUserDetailsTrackingForTests()">
                        <img class="bnnr-img m-hide" src="assets/img/assessment/default-assessment-banner.png" alt="" />
                        <img class="bnnr-img d-hide tab-hide" src="assets/img/assessment/default-assessment-mob-banner.png" alt="" />
                        <img class="bnnr-img tab-show" src="assets/img/assessment/default-assessment-tab-banner.png" alt="" />
                    </div>
                  </ng-container>  
                  <ng-container *ngIf="showDefault == false">
                    <div class="UNFAPP-hero-bnnr" (click)="fireBaseUserDetailsTrackingForTests()"> 
                        <a href="{{redirectUrl}}" class="UNFAPP-hero-bnnr">                      
                            <img class="bnnr-img m-hide" src="{{imageUrl_web}}" alt="" />
                            <img class="bnnr-img d-hide tab-hide" src="{{imageUrl_mob}}" alt="" />
                            <img class="bnnr-img tab-show" src="{{imageUrl_tab}}" alt="" />
                        </a> 
                    </div>
                  </ng-container>

                  <ng-container>
                    <div class="UNFAPP-asmnt-hdng-area" *ngIf="displayGrade !=1 && displayGrade !=2 && displayExamName!='APTITUDETEST'">
                        <h3 class="UNFAPP-hdng">My Reports</h3>
                    </div>

                    <!-- for first time user who not given any test -->
                    <div class="UNFAPP-asmnt-rpt-lstarea" *ngIf="displayGrade !=1 && displayGrade !=2 && displayExamName!='APTITUDETEST' && report?.completedtests==0; else displayGrade !=1 && displayGrade !=2 && displayExamName!='APTITUDETEST' && nonZeroTests">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="UNFAPP-asmnt-bx">
                                    <div class="UNFAPP-asmnt-icon-info">
                                        <img class="img-chart-icon" src="assets/img/my-report-icon.svg" alt="">
                                        <div>
                                            <h4 class="UNFAPP-cunt sm addbtmgap">Report and statistics will be generated once you take a test</h4>
                                            <h3 class="UNFAPP-icnhdng nobtmgap">Start with one of the tests below</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- for existing user who given test -->
                    <ng-template #nonZeroTests>
                        <div class="UNFAPP-asmnt-reprt-num-area" >
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="UNFAPP-asmnt-num-rptbx">
                                        <div class="UNFAPP-asmnt-num-wrap">
                                            <img src="assets/img/assessment/test-icon.svg" />
                                            <div class="UNFAPP-asmnt-num-info">
                                                <h3>Tests Taken</h3>
                                                <h2><b>{{report.completedtests}}</b> /{{report.totaltests}}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="UNFAPP-asmnt-num-rptbx _type2">
                                        <div class="UNFAPP-asmnt-num-wrap">
                                            <img src="assets/img/assessment/time-icon.svg" />
                                            <div class="UNFAPP-asmnt-num-info">
                                                <h3><span class="deskhide">Time Spent</span><span class="mobhide">Total Time Spent on Tests</span></h3>
                                                <h2><b>{{report.totaltimespent}}</b></h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-4 col-6">
                                    <div class="UNFAPP-asmnt-num-rptbx type2">
                                        <div class="UNFAPP-asmnt-num-wrap">
                                            <img src="assets/img/assessment/streak-icon.svg" />
                                            <div class="UNFAPP-asmnt-num-info">
                                                <h3>Your Highest Score</h3>
                                                <h2><b>{{report.highestscore}}</b> /{{report.outofscore}}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="upcomingTestDetails && upcomingTestDetails.length > 0">
                    <div class="UNFAPP-asmnt-hdng-area" >
                        <h3 class="UNFAPP-hdng">Upcoming Tests</h3>
                    </div>
                     <div class="UNFAPP-asmnt-upcmng-secn">
                        <div class="row">
                            <div class="col-md-4 col-10" *ngFor="let testData of upcomingTestDetails; index as j">
                                <!-- <p>{{testData.test_type[0].name}}</p> -->
                                <app-upcoming-box [testData]="testData" (testRegister)="registerNowPreStep(examName == 'JEEADVANCED' ? testData?.allScheduleids :[testData],testData.test_type)" 
                                (testattempt)="attemptTest(testData, testData.test_type)"  [pagetype]="'test'" [courseType]="examName"> </app-upcoming-box>    
                            </div>
                        </div>
                    </div>
                </ng-container>

                  <div class="UNFAPP-asmnt-hdng-area" *ngIf="infoBoxes && infoBoxes.length > 0">
                      <h3 class="UNFAPP-hdng">Tests</h3>
                  </div>

                  <div class="UNFAPP-asmnt-testbx-lstarea" *ngIf="showInfoBox && infoBoxes && infoBoxes.length > 0">
                      <div class="row">
                          <ng-container *ngFor="let infobox of infoBoxes; index as i">
                            <div class="col-lg-4" >
                                <app-info-box (testRegister)="registerNowPreStep($event?.tests, $event?.examtype)" 
                                [latestTimeboundTest]="latestTimeboundTests[infobox.examtype]" [infobox]="infobox" 
                                [examName]="examName" [type]="'noUpcoming'" [index]="i"></app-info-box>
                            </div>
                          </ng-container>
                         <!-- //?Grde 10 pyp-pdf  -->
                        <ng-container *ngIf="showPypPDfBox && enablePypPdf">
                            <div class="col-lg-4">
                                <div class="UNFAPP-asmnt-testbx cursor-pointer" (click)="gotoPdfList()">
                                    <div class="UNFAPP-tests-hwrp">
                                        <h2 class="h2-testbx-hdng UFAPP-Tsts-textalgn">Previous Year Papers (PYPs)</h2>
                                    </div>
                                    <div class="UNFAPP-asmnt-bx-actn">
                                        <div class="asmnt-cunt">
                                            <div class="UNFAPP-c-tooltip"><img src="assets/img/tooltip-info-icon.svg" class="info-tooltipicon" />
                                                <div class="UNFAPP-c-tooltip-box">
                                                    <h2 class="h2-tooltiip-heading">About Previous Year Papers (PYPs)</h2>
                                                    <p class="para">Revise and practice with previous year papers to stay on top of the latest pattern
                                                        and trends of questions.</p>
                                                </div>
                                            </div>
                                            <span (click)="gotoPdfList()" style="cursor: pointer;" *ngIf="true">
                                
                                               13 PYPs
                                                <i class="fa fa-caret-right" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                      </div>
                  </div>
              </div>
          </div><!-- right area full section closed-->
      </div>
  </div>
</div>